var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("ODA Charge Template")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to ODA Template List"
    },
    on: {
      "click": _vm.showODACharge
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("ODA Template Name")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ODATemplateName),
      expression: "ODATemplateName"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ODATemplateName",
      "id": "ODATemplateName",
      "placeholder": "Enter ODA Template Name"
    },
    domProps: {
      "value": (_vm.ODATemplateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ODATemplateName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ODATemplateName')),
      expression: "errors.has('ODATemplateName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter ODA template name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Distance Slab")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.distanceList,
      "placeholder": "Select Distance Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.setSelectedDistance
    },
    model: {
      value: (_vm.selectedDistance.id),
      callback: function($$v) {
        _vm.selectedDistance.id = $$v
      },
      expression: "selectedDistance.id"
    }
  })], 1), _vm._v(" "), (_vm.showSelectedDistanceError) ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select distance slab.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Weight Slab")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.weightList,
      "placeholder": "Select Weight Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.setSelectedWeight
    },
    model: {
      value: (_vm.selectedWeight.id),
      callback: function($$v) {
        _vm.selectedWeight.id = $$v
      },
      expression: "selectedWeight.id"
    }
  })], 1), _vm._v(" "), (_vm.showSelectedWeightError) ? _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select weight slab.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("ODA Template Description")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ODADescription),
      expression: "ODADescription"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "ODADescription",
      "id": "ODADescription",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.ODADescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ODADescription = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.matrixHeaderArray.length > 0 && _vm.matrixVerticalHeaderArray.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [(((_vm.selectedDistance.text || _vm.selectedWeight.text) && (_vm.selectedDistance.text && _vm.selectedWeight.text)) || ((!_vm.selectedDistance.text && !_vm.selectedWeight.text))) ? _c('div', [_c('label', [_vm._v("Charges (INR)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('matrix', {
    attrs: {
      "headerArray": _vm.matrixHeaderArray,
      "tableDataArray": _vm.matrixTableDataArray,
      "isSaveButtonHidden": _vm.isMatrixSaveButtonHidden,
      "verticalHeaderArray": _vm.matrixVerticalHeaderArray,
      "label": _vm.matrixLabel
    },
    on: {
      "updatedMatrixData": _vm.getUpdatedMatrixData
    }
  })], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.saveInfo()
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v("  \n            ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b691a2e","hasScoped":true}!./src/modules/masterdata/views/ODAChargeTemplate/createODACharge/createODACharge.component.html
// module id = 827
// module chunks = 3